<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal" class="white--text" :disabled="selectedItems.length === 0 || codes.length === 0"
                    v-bind="attrs" v-on="on">
                    {{ $t('changeCode') }}
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="(item, index) in codes" :key="index" @click="showSnack(item.value)">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-snackbar color="main--black" dark v-model="snackOpen" top>
            <span class="caption pr-4">{{ $t('changeCode') }}?</span>
            <div>
                <v-btn text class="text--main-yellow" @click="updateCodes" :disabled="isLoading">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import { CategoriesService } from '../../services'
import { MixinAppSnack } from '../../mixins'

export default {
    name: 'CategoryCodeDropdown',
    mixins: [MixinAppSnack],
    props: {
        selectedItems: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            currentCode: null,
            codes: [],
        };
    },
    computed: {},
    methods: {
        fetchCodes() {
            CategoriesService.getRedirectCodes()
                .then(response => {
                    this.codes = response.data;
                })
                .catch(error => {
                    console.error('Error fetching codes:', error);
                });
        },
        showSnack(code) {
            this.currentCode = code;
            this.snackOpen = true;
        },
        updateCodes() {
            this.isLoading = true;
            CategoriesService.updateCodes({
                ids: this.selectedItems,
                code: this.currentCode
            })
                .then(response => {
                    this.closeSnack();
                    this.$emit('update', { type: 'code', data: response.data });
                })
                .catch(error => {
                    this.closeSnack();
                    console.error('Error updating codes:', error);
                    this.$emit('error', { type: 'code', data: error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
    created() {
        CategoriesService.setAuth(this.$store.getters.token)
        this.fetchCodes();
    },
}
</script>

<style scoped></style>
